import { ImageTrackingProps } from "../hooks/use8thWall";

export const imageTrackingPipeline = (
  xr8: any,
  imageTrackingProps: ImageTrackingProps
) => {
  xr8.XrController.configure({ imageTargets: imageTrackingProps.imageTargets });

  const showTarget = (detail: any) => {
    imageTrackingProps.foundTarget(detail);
  };

  // Hides the image frame when the target is no longer detected.
  const hideTarget = (detail: any) => {
    imageTrackingProps.lostTarget(detail);
  };

  const onStart = () => {
    console.log("starting image tracking");
  };

  return {
    name: "image-tracking-pipeline",
    onStart,
    listeners: [
      { event: "reality.imagefound", process: showTarget },
      { event: "reality.imageupdated", process: showTarget },
      { event: "reality.imagelost", process: hideTarget },
    ],
  };
};
